import { processingSessionItemIdFormat } from "@redotech/redo-return-id";
import * as z from "zod";

export const LotCandidateSchema = z.object({
  lotNumber: z.string(),
  expirationDate: z.date().nullable(),
  quantityShipped: z.number(),
});
export type LotCandidate = z.infer<typeof LotCandidateSchema>;

export const getLotCandidatesForReturnItem = {
  name: "getLotCandidatesForReturnItem" as const,
  input: z.object({
    sessionItemId: processingSessionItemIdFormat.schema,
    /** Case-insensitive substring match against lot_number. */
    lotNumberSearch: z.string().nullish(),
  }),
  output: z.discriminatedUnion("isLotTracked", [
    z.object({ isLotTracked: z.literal(false) }),
    z.object({
      isLotTracked: z.literal(true),
      currentLot: z
        .object({ lotNumber: z.string(), expirationDate: z.date().nullable() })
        .nullable(),
      candidates: z.array(LotCandidateSchema),
    }),
  ]),
};
